// extracted by mini-css-extract-plugin
export default {"userWayContainer":"UserWay_userWayContainer__jiQ3M","userWayImage":"UserWay_userWayImage__16x9d"};